/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
// import DatePicker, { DateObject } from "react-multi-date-picker"
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"
// import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as PlusIcon } from "../../Assets/svg/PlusIcon.svg";
import { ReactComponent as PlusIconWhite } from "../../Assets/svg/PlusIconWhite.svg";
import { ReactComponent as DangerHome } from "../../Assets/svg/DangerHome.svg";
import { ReactComponent as SendMessageIcon } from "../../Assets/svg/SendMessageIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as LocationIcon } from "../../Assets/svg/LocationIcon.svg";
import { ReactComponent as NeshanegozariIcon } from "../../Assets/svg/NeshanegozariIcon.svg";
import { ReactComponent as ReportIcon } from "../../Assets/svg/ReportIcon.svg";
import moment from "moment-jalaali"
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import { ReactComponent as MoneyReaportIcon } from "../../Assets/svg/MoneyReaportIcon.svg";
import { labelColors, messageTemplate } from "../../api/ListData"

// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
// import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import ButtonNavigation from '../../Components/ButtonNavigation';
// import PropItem from '../../Components/PropItem';
import { json, useNavigate } from 'react-router-dom';
import { ReactComponent as PersonIcon } from "../../Assets/svg/PersonIcon.svg";
import { ReactComponent as SettingDarkGray } from "../../Assets/svg/SettingDarkGray.svg";
import { ReactComponent as ArrowRightIconTransparent } from "../../Assets/svg/ArrowRightIconTransparent.svg";
import { ReactComponent as GrayCalendarIcon } from "../../Assets/svg/GrayCalendarIcon.svg";
import { ReactComponent as ClockIcon } from "../../Assets/svg/ClockIcon.svg";
import { ReactComponent as GreenArrow } from "../../Assets/svg/greenArrow.svg";
import { ReactComponent as MobileGrayIcon } from "../../Assets/svg/MobileGrayIcon.svg";
import { ReactComponent as NotifIcon } from "../../Assets/svg/NotifIcon.svg";
import { ReactComponent as LampIcon } from "../../Assets/svg/LampIcon.svg";
import { ReactComponent as MailIcon } from "../../Assets/svg/MailIcon.svg";
import { ReactComponent as ExitIcon } from "../../Assets/svg/ExitIcon.svg";
// import { useSearchPropStore } from '../../store/searchProperty';
import Radio from '@mui/material/Radio';
import UserItem from './Components/UserItem';
import UsersDropZone from '../../Components/UsersDropZone';
import { useUserStore } from '../../store/user';
import ButtonNavigation from '../../Components/ButtonNavigation';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../../Components/persian-mobile-datepicker-config'
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import MyInfoModal from '../../Components/MyInfoModal';
import { GetAgency, SearchCities, lightOrDark, newShade, setLocationIdCookie, setLocationNameCookie, setUserCookie } from '../../Components/PublicFunctions';
import ModalComponent from '../../Components/ModalComponent';
import { useSearchPropStore } from '../../store/searchProperty';
import { useLocation } from "react-router-dom";
import Cookies from 'js-cookie'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function Settings(props) {

    const { enqueueSnackbar } = useSnackbar();

    const location = useLocation();
    console.log("location.state", location.state)
    const [openSettingModal, setOpenSettingModal] = useState(false)
    const [appVersion, setAppVersion] = useState("")
    const [openLocalModal, setOpenLocalModal] = useState(false)
    const [openDepositeModal, setOpenDepositeModal] = useState(false)
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [openAddUser, setOpenAddUser] = useState(false)
    const [openEditUser, setOpenEditUser] = useState(false)
    const [openEditSubUser, setOpenEditSubUser] = useState(false)
    const [deposit, setDeposit] = useState("")
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [Users, setUsers] = React.useState([]);
    const [ofsset, setOfsset] = React.useState(0);
    const [hasMore, setHasMore] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [propKey, setPropKey] = React.useState(0);
    const [inPlusing, setInPlusing] = React.useState(true);
    const [userImg, setUserImg] = useState(null);
    const [userFullName, setUserFullName] = useState("");
    const [userMobile, setUserMobile] = useState("");
    const [userPass, setUserPass] = useState("");
    const [editUserImg, setEditUserImg] = useState(null);
    const [uploadedImg, setUploadedImg] = useState("");
    const [editUserFullName, setEditUserFullName] = useState("");
    const [editUserMobile, setEditUserMobile] = useState("");
    const [editUserPass, setEditUserPass] = useState("");
    const [editUserId, setEditUserId] = useState("");
    const [areaDisplay, setAreaDisplay] = useState(1);
    const [deleteAreaModal, setDeleteAreaModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [newArea, setNewArea] = useState("");
    const [createAreaLoading, setCreateAreaLoading] = useState(false);
    const [ofssetFlag, setOfssetFlag] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [editAreaModal, setEditAreaModal] = useState(false);
    const [editItem, setEditItem] = useState({});
    const [editLoading, setEditLoading] = useState(false);
    const [financialModal, setFinancialModal] = useState(false);
    const [financialLoading, setFinancialLoading] = useState(false);
    const [financialRows, setFinancialRows] = useState([]);
    const [filterModal, setFilterModal] = useState(false);
    const [filterByDate, setFilterByDate] = useState("");
    const [filterByStatus, setFilterByStatus] = useState("");
    const [costumInputShow, setCostumInputShow] = useState(false);
    const [myInfoModal, setMyInfoModal] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [openProvinceModal, setOpenProvinceModal] = React.useState(false);
    const [provinceSelected, setProvinceSelected] = React.useState(false);
    const [province, setProvince] = React.useState(null);
    const [city, setCity] = React.useState(null);
    const [cityTitle, setCityTitle] = React.useState(null);
    const [cityProvince, setCityProvince] = React.useState([]);
    const [labelTitleSelected, setLabelTitleSelected] = React.useState("");
    const [labelColorSelected, setLabelColorSelected] = React.useState("#aeaeae");
    const [labelSelectedEdit, setLabelSelectedEdit] = React.useState({
        Text: "",
        ColorCode: "#aeaeae",
        Id: ""
    });

    const [permissionsModal, setPermissionsModal] = React.useState(false);

    const [texttemplate, setTexttemplate] = React.useState("");

    const [areaPermissModal, setAreaPermissModal] = useState(false)
    const [permissions, setPermissions] = useState([]);
    const [permissionsUser, setPermissionsUser] = useState("");

    const [myInfoList, setMyInfoList] = React.useState({});
    const [showSubmitDatePicker, setShowSubmitDatePicker] = React.useState(false);
    const [possiblitiModal, setPossiblitiModal] = React.useState(false);

    const [deleteUserModal, setDeleteUserModal] = useState(false);
    const [deleteLabelModal, setDeleteLabelModal] = useState(false);
    const [userDeleteLading, setUserDeleteLading] = useState(false);
    const [labelDeleteLading, setLabelDeleteLading] = useState(false);
    const [userDeleteId, setUserDeleteId] = useState("");
    const [supportModal, setSupportModal] = useState(false);
    const [labelsModal, setLabelsModal] = useState(false);
    const [addLabelsModal, setAddLabelsModal] = useState(false);
    const [labelsLoading, setLabelsLoading] = useState(false);
    const [editLabelModal, setEditLabelModal] = useState(false);
    const [labels, setLabels] = useState([]);
    const [messageTemplateModal, setMessageTemplateModal] = useState(false);
    const [subUserInfo, setSubUserInfo] = useState({});

    const setSearchData = useSearchPropStore((state) => state.setSearchData)


    const navigate = useNavigate();

    const userInfo = JSON.parse(localStorage.getItem("agency"))

    const dataFetchedRef = useRef(false);

    const accessToken = useUserStore((state) => state.accessToken)
    const locationId = useUserStore((state) => state.locationId)
    const locationName = useUserStore((state) => state.locationName)
    const setLocationName = useUserStore((state) => state.setLocationName)
    const setLocationId = useUserStore((state) => state.setLocationId)
    const setUserInfo = useUserStore((state) => state.setUserInfo)



    const handleClickOpenSettingModal = () => {
        setOpenSettingModal(true);
    };
    const handleOpenSettingModalClose = () => {
        setOpenSettingModal(false);
    };

    const handlePossiblitiModalOpen = () => {
        setPossiblitiModal(true);
    };
    const handlePossiblitiModalClose = () => {
        setPossiblitiModal(false);
    };

    const handleMessageTemplateModalOpen = () => {
        setMessageTemplateModal(true);
        setTexttemplate(Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Templates.length ? JSON.parse(Cookies.get('agency')).Templates[0].Content : "")
    };
    const handleMessageTemplateModalClose = () => {
        setMessageTemplateModal(false);
    };

    const handleSetTemplate = async () => {
        handleToggleBackdrop()

        if (userInfo.Templates && userInfo.Templates.length) {
            try {
                const response = await http({
                    url: "/webapp/message_templates/update",
                    method: "POST",
                    data: {
                        "Content": texttemplate,
                        "Id": JSON.parse(Cookies.get('agency')).Templates[0].Id
                    },
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                })

                console.log(response)
                if (response.data.result) {
                    let agencyTmp = JSON.parse(Cookies.get('agency'))
                    agencyTmp.Templates[0].Content = texttemplate
                    localStorage.setItem('agency', JSON.stringify(agencyTmp))
                    setUserCookie(agencyTmp)
                    handleMessageTemplateModalClose()
                    const variant = 'success'
                    enqueueSnackbar("قالب پیام با موفقیت ثبت شد.", { variant });
                }


            } catch (e) {
                console.log("error", e)
            }
        } else {

            try {
                const response = await http({
                    url: "/webapp/message_templates/create",
                    method: "POST",
                    data: {
                        "Content": texttemplate
                    },
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                })

                console.log(response)
                if (response.data.result) {
                    let agencyTmp = JSON.parse(Cookies.get('agency'))
                    if (agencyTmp.Templates.length)
                        agencyTmp.Templates[0].Content = texttemplate
                    else
                        agencyTmp.Templates.push({ Content: texttemplate })
                    localStorage.setItem('agency', JSON.stringify(agencyTmp))
                    setUserCookie(agencyTmp)
                    handleMessageTemplateModalClose()
                    const variant = 'success'
                    enqueueSnackbar("قالب پیام با موفقیت ثبت شد.", { variant });
                }


            } catch (e) {
                console.log("error", e)
            }
        }
        handleCloseBackdrop()
    }

    const handleDelLabelModal = () => {
        setDeleteLabelModal(true);
    };
    const handleDelLabelModalClose = () => {
        setDeleteLabelModal(false);
    };

    const handleEditLabelModal = (id, title, color) => {
        setEditLabelModal(true);
        const tmpLabelSelected = { ...labelSelectedEdit }
        tmpLabelSelected.Text = title
        tmpLabelSelected.Id = id
        tmpLabelSelected.ColorCode = color
        setLabelSelectedEdit(tmpLabelSelected)
    };
    const handleEditLabelModalClose = () => {
        setEditLabelModal(false);
        setLabelSelectedEdit({
            Text: "",
            ColorCode: "#aeaeae",
            Id: ""
        })
    };

    const handleEditLabel = async () => {
        handleToggleBackdrop()
        try {
            const response = await http({
                url: "/webapp/labels/update",
                method: "POST",
                data: labelSelectedEdit,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result.result) {
                handleEditLabelModalClose()

                getLabels()
            }

        } catch (e) {
            console.log("error", e)

        }

        handleCloseBackdrop()
    }

    const handleDeleteLabel = async () => {
        setLabelDeleteLading(true)
        try {
            const response = await http({
                url: "/webapp/labels/delete",
                method: "POST",
                data: {
                    "Id": labelSelectedEdit.Id
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result.result) {
                const variant = 'success'
                enqueueSnackbar("نشان شما با موفقیت حذف شد.", { variant });
                handleEditLabelModalClose()
                handleDelLabelModalClose()
                getLabels()
            }

        } catch (e) {
            console.log("error", e)

        }

        setLabelDeleteLading(false)

    }

    const getLabels = async () => {
        setLabelsLoading(true)
        try {
            const response = await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/labels",
                method: "POST",
                data: {
                    "Type": 1
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result.result) setLabels(response.data.result.result)

            setLabelsLoading(false)

        } catch (e) {
            console.log("error", e)
            setLabelsLoading(false)
        }
    }

    const handleClickLabelsModal = async () => {
        setLabelsModal(true);
        handleOpenSettingModalClose()
        getLabels()
    };
    const handleLabelsModalClose = () => {
        handleClickOpenSettingModal()
        setLabelsModal(false);
    };

    const handleClickAddLabelsModal = () => {
        setAddLabelsModal(true);
        handleLabelsModalClose()
    };
    const handleAddLabelsModalClose = () => {
        handleClickLabelsModal()
        setAddLabelsModal(false);
    };

    const handleOpenMyInfoModal = () => {
        setMyInfoModal(true);
        setMyInfoList({
            RegisterDate: userInfo.RegisterDate * 1000,
            AgencyName: userInfo.AgencyName,
            AgencyMobile: userInfo.AgencyMobile,
            Username: userInfo.Username,
            AgencyTel: userInfo.AgencyTel,
            AtomEmail: userInfo.AtomEmail,
            Website: userInfo.Website,
            Area: userInfo.Area,
            PhysicalAddress: userInfo.PhysicalAddress,
            LocationId: Cookies.get('locationId')
        })

    };
    const handleMyInfoModalClose = () => {
        setMyInfoModal(false);
    };

    const handleOpenSupportModal = () => {
        setSupportModal(true);
    };
    const handleSupportModalClose = () => {
        setSupportModal(false);
    };

    const handleClickOpenLocalModal = () => {
        setOpenLocalModal(true);
    };
    const handleOpenLocalModalClose = () => {
        setOpenLocalModal(false);
    };

    const handleClickOpenDepositeModal = () => {
        setOpenDepositeModal(true);
    };
    const handleOpenDepositeModalClose = () => {
        setOpenDepositeModal(false);
    };

    const handleClickOpenAddUserModal = () => {
        setOpenAddUser(true);
    };
    const handleOpenAddUserModalClose = () => {
        setOpenAddUser(false);
    };

    const handleClickOpenEditUserModal = (userInfo) => {
        console.log("userInfo", userInfo)
        if (userInfo.FullName) {
            setEditUserFullName(userInfo.FullName)
            setEditUserMobile(userInfo.AgencyMobile)
            setEditUserId(userInfo.Id)
            setUploadedImg(userInfo.Avatar)
            setOpenEditUser(true);

        } else {
            setEditUserFullName(userInfo.username)
            setEditUserMobile("")
            setEditUserId(userInfo.id)
            setUploadedImg("")
            setOpenEditSubUser(true)
        }
    };
    const handleEditUserModalClose = () => {
        setOpenEditUser(false);
    };

    const handleEditSubUserModalClose = () => {
        setOpenEditSubUser(false);
    };

    const handleClickFilterModal = () => {
        setFilterModal(true);
    };
    const handleFilterModalClose = () => {
        setFilterModal(false);
    };

    const handleClickPermissionsModal = (Permissions, user) => {
        setPermissionsUser({
            "user_id": user.id,
            "username": user.username
        })

        setPermissions(Permissions)
        console.log("permissions", permissions)

        setPermissionsModal(true);
    };
    const handlePermissionsModalClose = () => {
        setPermissionsModal(false);
    };

    const handleChangeFilterDate = (e) => {
        setFilterByDate(e.target.value);
        if (e.target.value != "costum")
            setCostumInputShow(false)
        else
            setCostumInputShow(true)
        console.log(e.target.value)
    };
    const handleChangeFilterStatus = (e) => {
        setFilterByStatus(e.target.value);

        console.log(e.target.value)
    };

    const handleClickAreaPermissModal = () => {
        setAreaPermissModal(true);
    };
    const handleAreaPermissModalClose = () => {
        setAreaPermissModal(false);
    };


    const handleFinancialModal = async () => {
        getFinancialReports()
        // setFinancialLoading(true)
        setFinancialModal(true);
        // try {
        //     await http({
        //         // url of the api endpoint (can be changed)
        //         url: "/wallet/transactions",
        //         method: "POST",
        //         data: {
        //             "Version": "4.2.2"
        //         },
        //         headers: {
        //             "Authorization": `Bearer ${Cookies.get('token')}`
        //         }
        //     }).then((res) => {

        //         console.log(res);
        //         setFinancialRows(res.data.result.transactions)
        //         setFinancialLoading(false)
        //     });
        // } catch (e) {

        //     console.log("error", e)


        //     setFinancialLoading(false)


        // }

    };
    const handleFinancialModalClose = () => {
        setFinancialModal(false);
    };

    const handleClickOpenDeleteAreaModal = (id) => {
        setDeleteId(id)
        setDeleteAreaModal(true);
    };
    const handleDeleteAreaModalClose = () => {
        setDeleteAreaModal(false);
    };

    const handleClickOpenDeleteUserModal = (id) => {
        setUserDeleteId(id)
        setDeleteUserModal(true);
    };
    const handleDeleteUserModalClose = () => {
        setDeleteUserModal(false);
    };


    const handleClickOpenUsersModal = () => {
        // setOfsset(0)
        getUsers(true)
        // setTimeout(function () {
        //     if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
        //         console.log("Users Use")
        //         document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
        //         return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
        //     }
        // }, 500)
        setOpenUsersModal(true);
    };
    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };




    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleEditAreaModalOpen = (id, name) => {
        setEditItem({
            "Id": id,
            "Name": name,
        })
        setEditAreaModal(true);
    };
    const handleEditAreaModalClose = () => {
        setEditAreaModal(false);
    };

    const handleAddUser = async () => {
        handleToggleBackdrop()

        let formData = new FormData();
        formData.append("Avatar", userImg);
        formData.append('FullName', userFullName)
        formData.append('AgencyMobile', userMobile)
        formData.append('ClientSecret', userPass)
        formData.append('LocationId', locationId)
        formData.append('Post', "کاربر")
        formData.append('AppType', "Website")
        formData.append('Version', "4.2.2")

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/agencies/create",
                method: "POST",
                data: formData,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("کاربر شما با موفقیت ثبت شد.", { variant });
                    getUsers(true)
                    setTimeout(function () {
                        if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
                            console.log("Users Use")
                            document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
                            return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
                        }
                    }, 500)
                    setUserImg(null)
                    setUserMobile("")
                    setUserFullName("")
                    setUserPass("")
                    handleOpenAddUserModalClose()
                }

            });
        } catch (e) {

            console.log("error", e.response.data.message)
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }

        }

        handleCloseBackdrop()
    }

    const handleEditUser = async () => {
        console.log("editUserImg", editUserImg)
        handleToggleBackdrop()

        let formData = new FormData();

        formData.append("Id", editUserId);
        formData.append("Avatar", editUserImg && editUserImg[0]);
        formData.append('FullName', editUserFullName)
        formData.append('AgencyMobile', editUserMobile)
        editUserPass && editUserPass != "" && formData.append('ClientSecret', editUserPass)
        formData.append('LocationId', locationId)
        formData.append('AppType', "Website")
        formData.append('Version', "4.2.2")

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/my_agencies/update",
                method: "POST",
                data: formData,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("کاربر شما با موفقیت ویرایش شد.", { variant });
                    getUsers(true)

                    GetAgency(setUserInfo, setSearchData, () => { }, http)
                    handleEditUserModalClose()
                }

            });
        } catch (e) {

            console.log("error", e.response.data.message)
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }

        }

        handleCloseBackdrop()
    }

    const handleEditSubUser = async () => {
        console.log("editUserImg", editUserImg)
        handleToggleBackdrop()



        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/users/update",
                method: "POST",
                data: {
                    username: editUserFullName,
                    password: editUserPass,
                    user_id: editUserId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("کاربر شما با موفقیت ویرایش شد.", { variant });
                    getUsers(true)
                }

            });
        } catch (e) {

            console.log("error", e.response.data.message)
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }

        }

        handleEditSubUserModalClose()

        handleCloseBackdrop()
    }

    const handleDeleteUser = async () => {

        setUserDeleteLading(true)
        console.log("userDeleteId", userDeleteId)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/my_agencies/delete",
                method: "POST",
                data: {
                    Id: userDeleteId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("کاربر شما با موفقیت حذف شد.", { variant });
                    setUserDeleteId("")
                    getUsers(true)
                    setTimeout(function () {
                        if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
                            console.log("Users Use")
                            document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
                            return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
                        }
                    }, 500)
                    setUserDeleteLading(false)

                    handleDeleteUserModalClose()
                    handleEditUserModalClose()
                }

            });
        } catch (e) {

            console.log("error", e.response.data.message)
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            setUserDeleteLading(false)


        }


    }

    const changeAccountStatus = async (userId, userImg, UserFullName, UserMobile, AccountStatus) => {
        handleToggleBackdrop()

        let formData = {}

        formData.Id = userId
        formData.Avatar = userImg;
        formData.FullName = UserFullName
        formData.AgencyMobile = UserMobile
        formData.LocationId = locationId
        formData.AccountStatus = AccountStatus
        formData.AppType = "Website"
        formData.Version = "4.2.2"

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/my_agencies/update",
                method: "POST",
                data: formData,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("کاربر شما با موفقیت فعال شد.", { variant });
                    getUsers(true)


                    try {
                        http({
                            // url of the api endpoint (can be changed)
                            url: "/authenticate/get/agency",
                            method: "GET",
                            headers: {
                                "Authorization": `Bearer ${Cookies.get('token')}`
                            }
                        }).then((res) => {
                            console.log("/authenticate/get/agency", res.data.result);
                            localStorage.setItem('agency', JSON.stringify(res.data.result.agency))
                            setUserCookie(res.data.result.agency)
                            localStorage.setItem('locationId', res.data.result.agency.LocationId)
                            setLocationIdCookie(res.data.result.agency.LocationId)
                            setUserInfo(res.data.result.agency)

                            handleEditUserModalClose()
                        });
                    } catch (e) {
                        console.log("error", e.response.data.message)
                        if (e.response.data.result == false) {
                            const variant = 'error'
                            enqueueSnackbar(e.response.data.message, { variant });
                        }
                    }

                }

            });
        } catch (e) {

            console.log("error", e.response.data.message)
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }

        }

        handleCloseBackdrop()
    }

    const handleClickOpenProvinceModal = () => {
        setOpenProvinceModal(true);
    };

    const handleProvinceClose = () => {
        setOpenProvinceModal(false);
    };



    const handleDeposit = () => {

        if (deposit != "") {
            handleToggleBackdrop()
            try {
                http({
                    url: "/wallet/charge",
                    method: "POST",
                    data: {
                        "Amount": deposit,

                    },
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    console.log("checkout_url", res)

                    if (res.data.ok == false) {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    } else {
                        window.open(res.data.result.checkout_url, '_blank', 'noreferrer');
                    }

                    handleCloseBackdrop()
                });

            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()


            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar("مبلغ را وارد کنید.", { variant });


        }
    };

    const getUsers = async () => {
        setUsersLoading(true)
        try {
            const usersRes = await http({
                url: "/users/get-my-users",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(usersRes)

            if (usersRes.data.result.Users.length) {
                setUsers(usersRes.data.result.Users)
            }

        } catch (e) {
            console.error(e);
        }

        setUsersLoading(false)
        // if (resetState) {
        //     setUsers([])
        //     console.log("reset", Users)
        //     setPropKey(propKey => propKey++)
        //     setOfsset(0);
        //     setHasMore(true)
        // }

        // setUsersLoading(true)

        // try {
        //     http({
        //         // url of the api endpoint (can be changed)
        //         url: "/users/get-my-users",
        //         method: "POST",
        //         data: {
        //             "Limit": 10,
        //             "Offset": ofsset
        //         },
        //         headers: {
        //             "Authorization": `Bearer ${accessToken}`
        //         }
        //     }).then((res) => {
        //         console.log("users", res.data.result.agencies);

        //         const tmpProp = [...Users]
        //         if (res.data.result.agencies.length > 0) {
        //             if (!resetState) {
        //                 res.data.result.agencies.map((item, index) => {
        //                     tmpProp.push(item)
        //                 })
        //                 setUsers(tmpProp)

        //                 setPropKey(propKey => propKey++)
        //             }
        //             else
        //                 setUsers(res.data.result.agencies)


        //             setPropKey(propKey => propKey++)

        //         } else {
        //             console.log("End")
        //             setHasMore(false)
        //             if (resetState) setUsers([])

        //         }

        //         console.log("users ff", Users)
        //         setUsersLoading(false)
        //         setTimeout(function () { setInPlusing(true) }, 1000)
        //     });

        // } catch (e) {
        //     console.error(e);
        //     setUsersLoading(false)

        // }

    }


    // const onScroll = () => {
    //     if (document.getElementById("dashboard-content")) {

    //         const scrollTop = document.getElementById("dashboard-content").scrollTop
    //         const scrollHeight = document.getElementById("dashboard-content").scrollHeight
    //         const clientHeight = document.getElementById("dashboard-content").clientHeight
    //         if (scrollTop + clientHeight >= scrollHeight && inPlusing) {
    //             setOfsset(ofsset => ofsset + 10);
    //             // setSearchData({"name":"Offset","value":ofsset})
    //             console.log("ofsset", ofsset)
    //             setInPlusing(false)
    //         }
    //     }
    // }

    // useEffect(() => {
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
    //             console.log("Users Use")
    //             document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
    //             return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
    //         }
    //     }, 500)


    // }, [Users])

    // useEffect(() => {
    //     console.log("offset use")

    //     if (hasMore && Users.length) {
    //         getUsers()
    //     }
    // }, [ofsset])


    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // getUsers()
        getProvinces()
        handleSeMyInfoList("AgencyMobile", userInfo.AgencyMobile)

        console.log("date", moment().locale('fa').format('dddd DD MMMM'))

        if (localStorage.getItem('subUserInfo'))
            setSubUserInfo(JSON.parse(localStorage.getItem('subUserInfo')))

        if (location.state && location.state.showLabel)
            handleClickLabelsModal()

        console.log("version", localStorage.getItem("appVersion"))
        if (localStorage.getItem("appVersion"))
            setAppVersion(localStorage.getItem('appVersion'))


    }, [])


    const handleLogOut = () => {
        localStorage.removeItem("token")
        localStorage.removeItem("provinces")
        localStorage.removeItem("agency")
        localStorage.removeItem("subUserInfo")

        Cookies.remove("token", { path: '' })
        Cookies.remove("provinces", { path: '' })
        Cookies.remove("agency", { path: '' })
        Cookies.remove("subUserInfo", { path: '' })

        navigate("/login")
    }


    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);
    const [areasItems, setAreasItems] = React.useState([]);

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {
            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 20);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    // useEffect(() => {
    //   console.log("hasMoreOffset",hasMoreOffset)
    // }, [hasMoreOffset])

    useEffect(() => {
        console.log("offset use sdfsd", areaOfsset)
        console.log("ofssetFlag", ofssetFlag)
        console.log("hasMoreOffset", hasMoreOffset)
        console.log("areasItems.length", areasItems.length)

        if (hasMoreOffset && areasItems.length && !ofssetFlag) {
            console.log("testsr", areaOfsset)
            if (areaDisplay == "1")
                getAreas(false, "", "/webapp/divar_areas/list")
            if (areaDisplay == "2")
                getAreas(false, "", "/areas/list")
        }

        if (ofssetFlag) {
            let url = ""
            if (areaDisplay == "1")
                url = "/webapp/divar_areas/list"
            if (areaDisplay == "2")
                url = "/areas/list"


            const data = {
                "LocationId": locationId,
                "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Offset": 0,
                "Limit": 20
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempAreas = [...areasItems]
                    if (res.data.result.items.length > 0) {

                        setAreasItems(res.data.result.items)

                        console.log("areasItems", areasItems)


                    } else {
                        console.log("End")
                        setHasMoreOffset(false)


                    }
                    setTimeout(function () { setAreaInPlusing(true) }, 3000)
                    setOfssetFlag(false)
                    setAreasLoading(false)


                });
            } catch (e) {
                console.error(e);
                setAreasLoading(false)
            }

        }


    }, [areaOfsset])

    useEffect(() => {
        console.log("offset use sdfsd", areaOfsset)
        console.log("ofssetFlag", ofssetFlag)


        if (ofssetFlag) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)

            let url = ""
            if (areaDisplay == "1")
                url = "/webapp/divar_areas/list"
            if (areaDisplay == "2")
                url = "/areas/list"


            const data = {
                "LocationId": locationId,
                "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Offset": 0,
                "Limit": 20
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempAreas = [...areasItems]
                    if (res.data.result.items.length > 0) {

                        setAreasItems(res.data.result.items)

                        console.log("areasItems", areasItems)


                    } else {
                        if (isDelete) {
                            setAreasItems(res.data.result.items)
                            setIsDelete(false)
                        } else {
                            console.log("End")
                            setHasMoreOffset(false)

                        }


                    }
                    setTimeout(function () { setAreaInPlusing(true) }, 3000)
                    setOfssetFlag(false)
                    setAreasLoading(false)


                });
            } catch (e) {
                console.error(e);
                setAreasLoading(false)
            }

        }


    }, [ofssetFlag])

    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
            console.log("offse", areaOfsset)
        }


        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),

            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 20
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 3000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }

    useEffect(() => {
        console.log("areaDisplay", areaDisplay)
        // setAreaOfsset(0)
        setOfssetFlag(true)
        // if (areaDisplay == "1")
        //     getAreas(true, "", "/webapp/divar_areas/list")
        // if (areaDisplay == "2")
        //     getAreas(true, "", "/areas/list")

    }, [areaDisplay])
    ///////////////////////

    const deleteArea = () => {
        console.log("deleteId", deleteId)
        console.log("token", Cookies.get('token'))

        setDeleteLading(true)
        try {
            http({
                url: "/areas/delete",
                method: "POST",
                data: {
                    "Id": parseInt(deleteId)
                },
                headers: {

                    "Authorization": `Bearer ${Cookies.get('token')}`

                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)
                setIsDelete(true)
                setAreaOfsset(0);
                setDeleteId("")
                handleDeleteAreaModalClose()
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده مورد نظر با موفقیت حذف شد.", { variant });
                }
                setDeleteLading(false)


            });
        } catch (e) {
            console.error(e);
            setDeleteLading(false)

        }
    }

    const createArea = () => {
        console.log("newArea", newArea)

        setCreateAreaLoading(true)
        try {
            http({
                url: "/areas/create",
                method: "POST",
                data: {
                    "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                    "Name": newArea,
                    "LocationId": locationId
                },
                headers: {

                    "Authorization": `Bearer ${Cookies.get('token')}`

                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)

                setAreaOfsset(0);

                setNewArea("")
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده با موفقیت اضافه شد.", { variant });
                }
                setCreateAreaLoading(false)

                // setTimeout(function () { getAreas(true, "", "/areas/list") }, 500)

            });
        } catch (e) {
            console.error(e);
            setCreateAreaLoading(false)

        }
    }

    const handleChangeEditItems = (name) => {
        let tmp = { ...editItem }
        tmp.Name = name
        setEditItem(tmp)
    }

    const handleEdit = () => {
        handleToggleBackdrop()


        try {
            http({
                url: "/areas/update",
                method: "POST",
                data: {
                    ...editItem,
                    LocationId: locationId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)

                setAreaOfsset(0);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده با موفقیت ویرایش شد.", { variant });
                }
                handleEditAreaModalClose()
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }
    }


    //financial Pagination
    const [FinancialOffset, setFinancialOffset] = React.useState(0);
    const [HasMoreFinancial, setHasMoreFinancial] = React.useState(true);
    const [FinancialInPlusing, setFinancialInPlusing] = React.useState(true);
    const [FinancialReport, setFinancialReport] = React.useState([]);
    const [FinancialOffsetFlag, setFinancialOffsetFlag] = useState(false);

    const FinancialReportOnScroll = () => {
        if (document.getElementById("FinancialReports-container")) {
            const scrollTop = document.getElementById("FinancialReports-container").scrollTop
            const scrollHeight = document.getElementById("FinancialReports-container").scrollHeight
            const clientHeight = document.getElementById("FinancialReports-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && FinancialInPlusing) {
                setFinancialInPlusing(false)
                setFinancialOffset(FinancialOffset => FinancialOffset + 1);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("FinancialOffset", FinancialOffset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("FinancialReports-container") !== 'undefined' && document.getElementById("FinancialReports-container") !== null && FinancialReport.length > 0) {
                document.getElementById("FinancialReports-container").addEventListener('scroll', FinancialReportOnScroll)
                return () => document.getElementById("FinancialReports-container").removeEventListener('scroll', FinancialReportOnScroll)
            }
        }, 500)
    }, [FinancialReport])

    // useEffect(() => {
    //   console.log("HasMoreFinancial",HasMoreFinancial)
    // }, [HasMoreFinancial])

    useEffect(() => {
        console.log("offset use sdfsd", FinancialOffset)
        console.log("FinancialOffsetFlag", FinancialOffsetFlag)
        console.log("HasMoreFinancial", HasMoreFinancial)
        console.log("FinancialReport.length", FinancialReport.length)

        if (HasMoreFinancial && FinancialReport.length && !FinancialOffsetFlag) {
            console.log("testsr", FinancialOffset)

            getFinancialReports(false, "")

        }




    }, [FinancialOffset])

    useEffect(() => {
        console.log("FinancialOffset change to 0", FinancialOffset)
        console.log("FinancialOffsetFlag", FinancialOffsetFlag)


        if (FinancialOffsetFlag) {
            setFinancialReport([])
            // setFinancialOffset(0);
            setHasMoreFinancial(true)

            setFinancialLoading(true)
            let url = "/wallet/transactions"


            const data = {
                // "LocationId": locationId,
                // "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Version": "4.2.2",
                "Offset": 0,
                "Limit": 20
            }
            if (filterByDate != "") {
                console.log("filterSet")
                if (filterByDate == "today") {
                    let date = new Date();
                    data["From"] = +date
                }
                if (filterByDate == "30") {
                    let today = new Date();
                    let priorDate = new Date(new Date().setDate(today.getDate() - 30));
                    data["From"] = +priorDate
                }
                if (filterByDate == "7") {
                    let today = new Date();
                    let priorDate = new Date(new Date().setDate(today.getDate() - 7));
                    data["From"] = +priorDate
                }
                if (filterByDate == "costum") {
                    data["From"] = fromDate
                    data["To"] = toDate
                }
            }

            if (filterByStatus != "") {
                console.log("filterSet")
                data["Status"] = filterByStatus
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempFinancialReports = [...FinancialReport]
                    if (res.data.result.transactions.length > 0) {

                        setFinancialReport(res.data.result.transactions)

                        console.log("FinancialReport", FinancialReport)


                    } else {
                        console.log("End")
                        setHasMoreFinancial(false)
                        // if (resetState) setFinancialReport([])

                    }
                    setTimeout(function () { setFinancialInPlusing(true) }, 3000)
                    setFinancialOffsetFlag(false)
                    setFinancialLoading(false)


                });
            } catch (e) {
                console.error(e);
                setFinancialLoading(false)
            }


        }


    }, [FinancialOffsetFlag])



    const getFinancialReports = (resetState = false, name = "", url = "/wallet/transactions") => {
        if (resetState) {
            setFinancialReport([])
            setFinancialOffset(0);
            setHasMoreFinancial(true)
            console.log("offse", FinancialOffset)
        }


        setFinancialLoading(true)


        const data = {
            // "LocationId": locationId,
            // "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Version": "4.2.2",
            "Offset": FinancialOffset,
            "Limit": 20
        }

        console.log("data", data)

        if (filterByDate != "") {
            console.log("filterSet")
            if (filterByDate == "today") {
                let date = new Date();
                data["From"] = +date
            }
            if (filterByDate == "30") {
                let today = new Date();
                let priorDate = new Date(new Date().setDate(today.getDate() - 30));
                data["From"] = +priorDate
            }
            if (filterByDate == "7") {
                let today = new Date();
                let priorDate = new Date(new Date().setDate(today.getDate() - 7));
                data["From"] = +priorDate
            }
            if (filterByDate == "costum") {
                data["From"] = fromDate
                data["To"] = toDate
            }
        }

        if (filterByStatus != "") {
            console.log("filterSet")
            data["Status"] = filterByStatus
        }

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempFinancialReports = [...FinancialReport]
                if (res.data.result.transactions.length > 0) {
                    if (!resetState) {
                        res.data.result.transactions.map((item, index) => {
                            tempFinancialReports.push(item)
                        })
                        setFinancialReport(tempFinancialReports)
                        console.log("resetState not")
                    }
                    else
                        setFinancialReport(res.data.result.transactions)

                    console.log("FinancialReport", FinancialReport)


                } else {
                    console.log("End")
                    setHasMoreFinancial(false)
                    if (resetState) setFinancialReport([])

                }
                setTimeout(function () { setFinancialInPlusing(true) }, 3000)
                setFinancialLoading(false)


            });
        } catch (e) {
            console.error(e);
            setFinancialLoading(false)

        }
    }

    // useEffect(() => {
    //     // console.log("FinancialReportDisplay", FinancialReportDisplay)
    //     // setFinancialOffset(0)
    //     setFinancialOffsetFlag(true)
    //     // if (FinancialReportDisplay == "1")
    //     //     getFinancialReports(true, "", "/webapp/divar_FinancialReports/list")
    //     // if (FinancialReportDisplay == "2")
    //     //     getFinancialReports(true, "", "/FinancialReports/list")

    // }, [FinancialReportDisplay])

    ///////////////////////

    const handleSetFilter = () => {
        // getFinancialReports(true)
        console.log("filterByDate", filterByDate)
        setFinancialReport([])
        setFinancialOffsetFlag(true)
        handleFilterModalClose()
    }



    const handleSetfromDate = (date, format = 'YYYY/MM/DD') => {
        let object = { date, format }
        console.log(new DateObject(object).toUnix())
        setFromDate(new DateObject(object).toUnix())
    }
    const handleSetToDate = (date, format = 'YYYY/MM/DD') => {
        let object = { date, format }
        console.log(new DateObject(object).toUnix())
        setToDate(new DateObject(object).toUnix())
    }


    const handleProvinceSelected = async (e) => {
        setProvince(e.target.value)
        handleToggleBackdrop()
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/locations/province/cities/list",
                method: "POST",
                data: {
                    "ProvinceId": e.target.value,
                }
            }).then((res) => {

                setCityProvince(res.data.result.Cities)
                setProvinceSelected(true)
                handleCloseBackdrop()

            });
        } catch (e) {
            console.error(e);

            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            handleCloseBackdrop()
        }
    };

    const handleSetCity = (e) => {
        console.log("city")
        setCity(e.target.value)
        setCityTitle(cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        console.log("cityTitle", cityTitle)
        console.log("city", city)
        console.log("province", province)
        setLocationId(e.target.value)
        localStorage.setItem("locationId", e.target.value)
        setLocationIdCookie(e.target.value)
        setLocationName(cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        localStorage.setItem("locationName", cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        setLocationNameCookie(cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        handleProvinceClose()
    }


    const handleBackToProvince = (e) => {
        console.log("back")
        setCity(null)
        setProvince(null)
        setCityTitle(null)
        setProvinceSelected(false)
        getProvinces()
    }

    const getProvinces = () => {
        if (!localStorage.getItem('provinces')) {
            http.post('/locations/provinces/list')
                .then(response => {
                    setCityProvince(response.data.result.Provinces)
                    localStorage.setItem('provinces', JSON.stringify(response.data.result.Provinces))
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
        } else {
            console.log(JSON.parse(localStorage.getItem('provinces')))
            setCityProvince(JSON.parse(localStorage.getItem('provinces')))
        }
    }

    const handleSearch = async (e) => {
        if (provinceSelected) {

            handleToggleBackdrop()
            try {
                await http({

                    url: "/locations/province/cities/list",
                    method: "POST",
                    data: {
                        "ProvinceId": province ? province : '',
                        "Name": e.target.value
                    }
                }).then((res) => {
                    setCityProvince(res.data.result.Cities)
                    setProvinceSelected(true)
                    handleCloseBackdrop()
                });
            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }



        } else {
            if (e.target.value != "") {
                console.log("SearchCities", SearchCities(e.target.value, cityProvince))
                setCityProvince(SearchCities(e.target.value, cityProvince))
            } else {
                getProvinces()
            }
        }

    }

    const handleSetCityInLocal = () => {
        console.log("city", city)
        console.log("province", province)
        setLocationId(city)
        localStorage.setItem("locationId", city)
        setLocationIdCookie(city)
        setLocationName(cityTitle)
        localStorage.setItem("locationName", cityTitle)
        setLocationNameCookie(cityTitle)
        handleProvinceClose()
    }

    useEffect(() => {
        setCityTitle(cityTitle)
    }, [cityTitle])


    const handleSetPermissions = (e, premSelected) => {
        let premTmp = [...permissions]
        // console.log(e.target.checked)

        if (e.target.checked) {
            if (!premTmp.includes(premSelected)) {
                premTmp.push(premSelected)
            }
        } else {
            if (premTmp.includes(premSelected)) {
                premTmp = premTmp.filter(item => item != premSelected)
            }
        }
        console.log("permissions", premTmp)
        setPermissions(premTmp)

    }


    const handleSendPermissions = async () => {
        console.log("permissionsUser", permissionsUser)
        let lastPermissionsUser = { ...permissionsUser }
        lastPermissionsUser.Permissions = permissions
        // lastPermissionsUser.AppType = "Website"
        // lastPermissionsUser.Version = "4.2.2"
        // delete lastPermissionsUser["RegistrarAgency"]
        Object.keys(lastPermissionsUser).map((item) => {
            if (lastPermissionsUser[item] == "0") {
                console.log("lastPermissionsUser[item]", item)
                delete lastPermissionsUser[item]
            }
        })
        console.log("lastPermissionsUser", lastPermissionsUser)

        handleToggleBackdrop()
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/users/update",
                method: "POST",
                data: lastPermissionsUser,
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            }).then((res) => {
                console.log(res)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("مجوز ها با موفقیت اعمال شد.", { variant });
                    getUsers(true)
                    handlePermissionsModalClose()
                }
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);

            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            handleCloseBackdrop()
        }
    }

    const handleSeMyInfoList = (infoItem, value, isArray = false, isAppend = false, isToggle = false) => {
        const tmp = { ...myInfoList }

        if (isAppend) {
            !tmp[infoItem] ? tmp[infoItem] = [] : null
            if (tmp[infoItem].includes(value)) {
                const index = tmp[infoItem].indexOf(value);
                const newItem = tmp[infoItem].filter((item, index) => item != value);
                console.log("newItem", newItem)
                tmp[infoItem] = newItem
            } else {
                tmp[infoItem].push(value)
            }

        } else {
            if (!isArray) {
                if (!isToggle)
                    tmp[infoItem] = value
                else {
                    if (tmp[infoItem].includes(value)) {
                        const index = tmp[infoItem].indexOf(value);
                        const newItem = tmp[infoItem].filter((item, index) => item != value);
                        console.log("newItem", newItem)
                        tmp[infoItem] = newItem
                    } else {
                        tmp[infoItem] = [value]
                    }
                }
            }
            else tmp[infoItem] = [value]
        }

        setMyInfoList(tmp)
        console.log("myInfoList", myInfoList)
    }


    const saveMyInfo = async () => {
        handleToggleBackdrop()

        myInfoList.AppType = "Website"
        myInfoList.Version = "4.2.2"
        myInfoList.Id = userInfo.Id;
        if (myInfoList.RegisterDate)
            myInfoList.RegisterDate = +myInfoList.RegisterDate / 1000
        // myInfoList.LocationId = Cookies.get('locationId')
        console.log("myInfoList", myInfoList)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/my_agencies/update",
                method: "POST",
                data: myInfoList,
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            }).then((res) => {
                console.log(res)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("اطلاعات شما با موفقیت ثبت شد.", { variant });
                    GetAgency(setUserInfo, setSearchData, setLocationName, http, true)
                    handleMyInfoModalClose()
                }
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }
    }


    const handleSetColor = (color) => {
        console.log(color)
    }

    const [mobileValidation, setMobileValidation] = useState(true)

    const handleSetUserMobile = (value) => {
        setUserMobile(value)

    }

    useEffect(() => {
        if (userMobile != "" && userMobile.length < 11) {
            setMobileValidation(false)
        } else {
            setMobileValidation(true)
        }

        console.log("mobileValidation", mobileValidation, userMobile.length)
    }, [userMobile])


    const handleSaveLabel = async () => {
        handleToggleBackdrop()
        try {
            const response = await http({
                url: "/webapp/labels/create",
                method: "POST",
                data: {
                    "AgencyId": userInfo.Id,
                    "Text": labelTitleSelected,
                    "ColorCode": labelColorSelected,
                    "Type": 1
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result) {
                const variant = 'success'
                enqueueSnackbar("نشان شما با موفقیت ثبت شد.", { variant });
                handleAddLabelsModalClose()
                setLabelTitleSelected("")
                setLabelColorSelected("#aeaeae")
            }
            handleCloseBackdrop()

        } catch (e) {
            console.error(e);
            handleCloseBackdrop()

        }
    }


    const handleSetTempText = (e) => {
        let tmp = texttemplate

        if (e.target.checked) {
            tmp = `${texttemplate} ${e.target.value} : [${(e.target.value.replaceAll(/\p{Emoji}/gu, "").trim())}]`

        } else {
            tmp = tmp.replaceAll(`${e.target.value} : [${(e.target.value.replaceAll(/\p{Emoji}/gu, "").trim())}]`, "")
        }

        setTexttemplate(tmp)
    }

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box id="dashboard-content" sx={{ height: 'calc(100vh - 76px)!important' }} >
                <Box className="setting-header">
                    <Box className="top-settings-header">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Box className="avatar-container">
                                {userInfo.Avatar && userInfo.Avatar != "" ? <img src={userInfo.Avatar} /> : <img src='./assets/img/User-avatar.svg.png' />}
                            </Box>
                            <Box>
                                <Typography component='p' sx={{ mb: 1, fontSize: '14px' }}>
                                    {Object.keys(subUserInfo).length ? subUserInfo?.username : userInfo.FullName}
                                </Typography>
                                <Typography component='p' sx={{ fontSize: '14px' }}>
                                    {userInfo.AgencyMobile}
                                </Typography>
                            </Box>
                        </Box>
                        <Box className="top-header-buttons">
                            <Button onClick={handleOpenMyInfoModal}>مشخصات</Button>
                            <Button onClick={handleLogOut}>خروج <ExitIcon /></Button>
                        </Box>
                    </Box>
                    <Box className="bottom-settings-header" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '45px', mt: 3 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box>
                                {/* موجودی {parseInt(userInfo.Credit).toLocaleString()} تومان */}
                            </Box>
                            {/* <Box>کاربران آنلاین 2 نفر</Box> */}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {/* <Button onClick={handleClickOpenDepositeModal} sx={{ border: '1px solid', color: '#096767', stroke: '#096767', borderRadius: '20px', fontSize: '13px', display: 'flex', gap: '5px' }}>
                                افزایش اعتبار <ArrowRightIconTransparent className='rotate-180-minus' />
                            </Button> */}
                            <Box></Box>
                            <Button sx={{ border: '1px solid', color: '#8F8F8F', stroke: '#8F8F8F', borderRadius: '20px', fontSize: '13px', display: 'flex', gap: '5px' }} onClick={handleClickOpenProvinceModal}>{locationName} <ArrowRightIconTransparent className='rotate-180-minus' /> </Button>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ p: 3 }}>
                    <Grid container spacing={2} className='setting-content'>
                        <Grid item xs={4}>
                            <Button className='yellow' onClick={handleClickOpenSettingModal}>
                                <SettingDarkGray />
                                <Typography component='span'>
                                    تنظیمات
                                </Typography>
                            </Button>
                        </Grid>
                        {subUserInfo?.is_master == 1 ? <Grid item xs={4}>
                            <Button className='light-blue1' onClick={handleClickOpenUsersModal}>
                                <PersonIcon width="23.627" height="23.583" />
                                <Typography component='span'>
                                    کاربران
                                </Typography>
                            </Button>
                        </Grid> : ''}
                        <Grid item xs={4}>
                            <Button className='dark-green'>
                                <ReportIcon />
                                <Typography component='span'>
                                    گزارشات
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button className='light-blue2' onClick={() => navigate('/calendar')}>
                                <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", gap: "10px" }}>
                                        <GrayCalendarIcon />
                                        <Typography component='span'>
                                            تقویم کاری
                                        </Typography>
                                    </Box>
                                    {/* <Box>2 اعلان</Box> */}
                                </Box>
                                <Box sx={{ textAlign: "start", width: "100%", mt: 1 }}>
                                    امروز {moment().locale('fa').format('dddd jDD jMMMM')}
                                </Box>
                            </Button>
                        </Grid>
                        <Grid item xs={8}>
                            <Button className='orange'>
                                <img src='./assets/img/ClockPriod.png' />
                                <Typography component='span'>
                                    منقضی شده ها
                                </Typography>
                            </Button>
                        </Grid>
                         {subUserInfo?.is_master == 1 ? <Grid item xs={4}>
                            <Button className='light-green' onClick={handleFinancialModal}>
                                <MoneyReaportIcon />
                                <Typography component='span'>
                                    گزارشات مالی
                                </Typography>
                            </Button>
                        </Grid> : ""} 
                        <Grid item xs={4}>
                            <Button className='green' onClick={handlePossiblitiModalOpen}>
                                <img src='/assets/img/امکانات.png' />
                                <Typography component='span'>
                                    امکانات پایش
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={8}>
                            <Button className='purple'>
                                <img src='/assets/img/PhoneIcon.png' />
                                <Typography component='span'>
                                    درحال پیگیری
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button className='light-blue2' onClick={handleOpenSupportModal}>
                                <img src='/assets/img/Suport.png' />
                                <Typography component='span'>
                                    پشتیبانی
                                </Typography>
                            </Button>
                        </Grid>
                        {/* <Grid item xs={4}>
                            <Button className='purple2'>
                                <img src='/assets/img/Education.png' />
                                <a href='https://app.payesh.me/learn/استفاده-از-نسخه-موبایل-و-وب-اپلیکیشن/' target='_blank'>
                                    آموزش
                                </a>
                            </Button>
                        </Grid> */}
                    </Grid>
                </Box>
                <div class="version-wrap">
                    نسخه {appVersion}
                </div>
            </Box>
            <ButtonNavigation />

            {openSettingModal && <ModalComponent showModalState={openSettingModal}
                handleModalClose={handleOpenSettingModalClose}
                modalTitle=""
                disableSubmitBtn={true}
                hasSpecificParent={true}>
                <Box sx={{ overflowX: 'hidden', p: 1 }}>
                    <Grid container spacing={1} className='setting-content'>
                        <Grid item xs={4}>
                            <Button className='yellow' onClick={handleClickLabelsModal}>
                                <NeshanegozariIcon />
                                <Typography component='span'>
                                    نشانه گذاری ها
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button className='light-blue1' onClick={handleClickOpenLocalModal}>
                                <LocationIcon />
                                <Typography component='span'>
                                    تعریف محدوده ها
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button className='dark-green'>
                                <DangerHome />
                                <Typography component='span'>
                                    نوع ملک ها
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button className='light-blue2' onClick={handleMessageTemplateModalOpen}>
                                <SendMessageIcon />
                                <Typography component='span'>
                                    قالب ارسال
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </ModalComponent>}

            {openLocalModal && <ModalComponent showModalState={openLocalModal}
                handleModalClose={handleOpenLocalModalClose}
                modalTitle="انتخاب محدوده"
                disableSubmitBtn={true}
                hasSpecificParent={true}>
                <Box sx={{ overflowX: 'hidden', p: 1 }}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        name="position"
                        defaultValue="end"
                        className='text-gray-f-13'
                        value={areaDisplay}
                    >
                        <FormControlLabel value={1} control={<Radio size="small" sx={{
                            color: '#29A19C', '&.Mui-checked': {
                                color: '#29A19C',
                            },
                        }} />} label="می خواهم ازمحدوده های پایش استفاده کنم" onChange={() => setAreaDisplay(1)} />
                        <FormControlLabel value={2} control={<Radio size="small" sx={{
                            color: '#29A19C', '&.Mui-checked': {
                                color: '#29A19C',
                            },
                        }} />} label="می خواهم ازمحدوده های خودم استفاده کنم" onChange={() => setAreaDisplay(2)} />
                    </RadioGroup>
                    {areaDisplay == 1 ? <Box>
                        <Typography component='p' sx={{ color: '#666666', fontSize: '14px', textAlign: 'center', mt: 2 }}>
                            محدوده های پیشنهادی پایش
                        </Typography>
                        <Box sx={{ mt: 3, color: '#8F8F8F' }}>

                            <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 220px)!important", overflow: 'auto' }} id="areas-container">
                                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                    {
                                        areasItems && areasItems.length > 0 ?
                                            areasItems.map((item, index) => (

                                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                    <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                    <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center' }}>
                                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                        {/* <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div> */}
                                                    </label>
                                                </Box>
                                            ))
                                            : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                    }
                                    {
                                        areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box> : null}
                    {areaDisplay == 2 ? <Box>

                        <Box sx={{ mt: 3, color: '#8F8F8F' }}>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase id='newAreas' value={newArea} onChange={(e) => setNewArea(e.target.value)} placeholder='محدوده دلخواه خود را وارد کنید' />
                            </Box>
                            <Button className='green-btn' onClick={createArea} sx={{ width: "100%", mx: 'auto', borderRadius: "25px", mt: 2 }}>
                                {!createAreaLoading ? "افزودن محدوده" : <img src="/assets/img/ladng2.gif" width="40" />}
                            </Button>
                            <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 300px)!important", overflow: 'auto' }} id="areas-container">
                                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                    {
                                        areasItems && areasItems.length > 0 ?
                                            areasItems.map((item, index) => (

                                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                    <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                    <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'right' }}>
                                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                        <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton onClick={() => handleEditAreaModalOpen(item.id, item.Name)}>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div>
                                                    </label>
                                                </Box>
                                            ))
                                            : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                    }
                                    {
                                        areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box> : null}
                </Box>
            </ModalComponent >}

            {openDepositeModal && <ModalComponent showModalState={openDepositeModal}
                handleModalClose={handleOpenDepositeModalClose}
                modalTitle=""
                hasSpecificParent={true}
                modalSubmitBtn={handleDeposit}
                modalTitleSubmitBtn="انتخاب">
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase id='deposit' value={deposit} onChange={(e) => setDeposit(e.target.value)} placeholder='مبلغ مورد نظر خود را وارد کنید' />
                        </Box>
                    </Box>
                </Box>
            </ModalComponent>}

            {openUsersModal && <ModalComponent showModalState={openUsersModal}
                handleModalClose={handleOpenUsersModalClose}
                modalTitle=""
                hasSpecificParent={true}
                disableSubmitBtn={true}>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 120px)!important" }} id="dashboard-content">
                    <Box >

                        <Box >
                            <UserItem userInfo={userInfo} isAgency={true} handleClickPermissionsModal={handleClickPermissionsModal} handleClickOpenEditUserModal={handleClickOpenEditUserModal} changeAccountStatus={changeAccountStatus} isAdmin={true} />
                        </Box>
                        <Button sx={{ width: "100%", borderRadius: "50px", bgcolor: "#29A19C!important", color: "#fff", display: "flex", gap: "7px", p: 2, mt: 2 }} onClick={handleClickOpenAddUserModal}>
                            <PlusIconWhite width="15px" />
                            افزودن کاربر
                        </Button>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }} key={propKey}>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (
                                        <UserItem key={index} userInfo={item} handleClickPermissionsModal={handleClickPermissionsModal} handleClickOpenEditUserModal={handleClickOpenEditUserModal} changeAccountStatus={changeAccountStatus} />
                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
            </ModalComponent>}

            {/* {openAddUser && <ModalComponent showModalState={openAddUser}
                handleModalClose={handleOpenAddUserModalClose}
                modalTitle=""
                hasSpecificParent={true}
                modalSubmitBtn={handleAddUser}
                modalTitleSubmitBtn="ثبت"
            >
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    <Box className="gray-box" sx={{ p: 2, borderRadius: "5px" }}>
                        به ازای هرکاربر روزانه مبلغ 1900 تومان از موجودی
                        شما کسر می شود لطفا ابتدا موجودی حساب خود را افزایش دهید.
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: "100%" }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <UsersDropZone userImg={userImg} setUserImg={setUserImg} />
                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='نام کاربر' value={userFullName} onChange={(e) => setUserFullName(e.target.value)} />
                            </Box>
                        </Box>
                        <Box>
                            <Box className={`inputs-container ${!mobileValidation && 'error'}`} sx={{ width: 'auto' }}>
                                <InputBase placeholder='شماره همراه' type='tel' inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} value={userMobile} onChange={(e) => handleSetUserMobile(e.target.value)} />
                            </Box>
                            {!mobileValidation ? <Typography variant='p' sx={{ color: '#d41d1d', fontSize: '12px', marginTop: '-10px' }}>شماره همراه باید 11 کاراکتر باشد.</Typography> : ''}

                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='کلمه عبور' type='password' onChange={(e) => setUserPass(e.target.value)} value={userPass} />
                            </Box>

                        </Box>
                        <Typography variant='p' sx={{ fontSize: '14px', marginTop: '10px' }}>کاربر زیر مجموعه شما با همین شماره همراه و کلمه عبور می تواند وارد پایش شود.</Typography>

                    </Box>
                </Box>
            </ModalComponent>} */}
            {
                openAddUser && <Dialog className="dialog-box"
                    open={openAddUser}
                    onClose={handleOpenAddUserModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" sx={{ textAlign: "justify" }}>
                            جهت افزودن کاربر ابتدا به سایت app.payesh.me  مراجعه کرده و نسخه ویندوزی را بطور رایگان دانلود و نصب کنید. سپس از قسمت سامانه امنیتی به بخش کاربران رفته و کاربر جدید را تعریف کنید.
                            در پایان از قسمت نمایه من دکمه همگام سازی را بزنید.
                            جهت آموزش به لینک زیر مراجعه کنید.
                            <a className='btn green-btn' style={{ display: "block", marginTop: "10px", padding: "10px", textAlign: "center" }} href='https://app.payesh.me/learn/استفاده-از-نسخه-موبایل-و-وب-اپلیکیشن/'>
                                آموزش استفاده از نسخه موبایل و وب
                            </a>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleOpenAddUserModalClose}>باشه</Button>

                    </DialogActions>
                </Dialog>
            }

            {openEditUser && <ModalComponent showModalState={openEditUser}
                handleModalClose={handleEditUserModalClose}
                modalTitle=""
                hasSpecificParent={true}
                modalSubmitBtn={handleEditUser}
                modalTitleSubmitBtn="ویرایش"
            // modalHeaderRightBtn={true}
            // headerRightBtnFunction={() => handleClickOpenDeleteUserModal(editUserId)}
            // headerRightBtnClass="rounded-50"
            // headerRightBtnTitle="حذف کاربر"
            // headerRightBtnStyle={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }}
            >
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: "100%" }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <UsersDropZone userImg={editUserImg} setUserImg={setEditUserImg} uploadedImg={uploadedImg} />
                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='نام کاربر' value={editUserFullName} onChange={(e) => setEditUserFullName(e.target.value)} />
                            </Box>
                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='شماره همراه' type='tel' inputProps={{ pattern: "\d*", maxlength: "11" }} value={editUserMobile} onChange={(e) => setEditUserMobile(e.target.value)} />
                            </Box>
                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='کلمه عبور' type='password' onChange={(e) => setEditUserPass(e.target.value)} value={editUserPass} autoComplete="off" />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </ModalComponent>}


            {openEditSubUser && <ModalComponent showModalState={openEditSubUser}
                handleModalClose={handleEditSubUserModalClose}
                modalTitle=""
                hasSpecificParent={true}
                modalSubmitBtn={handleEditSubUser}
                modalTitleSubmitBtn="ویرایش"
                modalHeaderRightBtn={true}
                headerRightBtnFunction={() => handleClickOpenDeleteUserModal(editUserId)}
                headerRightBtnClass="rounded-50"
                headerRightBtnTitle="حذف کاربر"
                headerRightBtnStyle={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }}
            >
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, width: "100%" }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <UsersDropZone userImg={editUserImg} setUserImg={setEditUserImg} uploadedImg={uploadedImg} />
                        </Box>
                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='نام کاربر' value={editUserFullName} onChange={(e) => setEditUserFullName(e.target.value)} />
                            </Box>
                        </Box>

                        <Box>
                            <Box className="inputs-container" sx={{ width: 'auto' }}>
                                <InputBase placeholder='کلمه عبور' type='password' onChange={(e) => setEditUserPass(e.target.value)} value={editUserPass} autoComplete="off" />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </ModalComponent>}

            {
                deleteUserModal && <Dialog className="dialog-box"
                    open={deleteUserModal}
                    onClose={handleDeleteUserModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید این کاربر را حذف کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteUserModalClose}>خیر</Button>
                        <Button onClick={handleDeleteUser} autoFocus>
                            {!userDeleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {
                deleteAreaModal && <Dialog className="dialog-box"
                    open={deleteAreaModal}
                    onClose={handleDeleteAreaModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید این محدوده را حذف کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteAreaModalClose}>خیر</Button>
                        <Button onClick={deleteArea} autoFocus>
                            {!deleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {editAreaModal && <ModalComponent showModalState={editAreaModal}
                handleModalClose={handleEditAreaModalClose}
                modalTitle="ویرایش محدوده"
                hasSpecificParent={true}
                modalSubmitBtn={handleEdit}
                modalTitleSubmitBtn="ویرایش"

            >
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase id='deposit' value={editItem.Name} onChange={(e) => handleChangeEditItems(e.target.value)} placeholder='عنوان محدوده را وارد کنید' />
                        </Box>
                    </Box>
                </Box>
            </ModalComponent>}

            {
                financialModal && <Dialog className="dialog-box"
                    fullScreen
                    open={financialModal}
                    onClose={handleFinancialModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: '#fff', color: '#666666' }}>
                        <Toolbar>

                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleFinancialModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 'auto', mr: 2, fontSize: "15px" }} variant="h6" component="div">
                                گزارشات مالی
                            </Typography>
                            <Button autoFocus className='green-btn' color="inherit" sx={{ fontSize: "12px" }} onClick={handleClickOpenDepositeModal}>
                                افزایش اعتبار
                            </Button>

                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 2, color: '#8F8F8F', pb: 3 }}>

                        <Box>
                            <Box sx={{ p: 2, color: '#8F8F8F', height: "calc(100vh - 135px)!important", overflow: 'auto' }} id="FinancialReports-container">
                                <Box sx={{ display: "flex", gap: "5px", mb: 2 }}>
                                    <Box>موجودی : </Box>
                                    <Box sx={{ display: "flex", gap: "5px" }}>
                                        <Typography variant='span'>{JSON.parse(Cookies.get('agency')).Credit}</Typography>
                                        <Typography variant='span'>تومان</Typography>
                                    </Box>
                                </Box>
                                <Button sx={{ display: "flex", gap: "5px", alignItems: "center", bgcolor: "#ECE9E9", color: "#8F8F8F", mb: 2 }} onClick={handleClickFilterModal}>
                                    <img src='/assets/img/filterIcon.png' />
                                    فیلتر ها
                                </Button>
                                <TableContainer component={Paper} sx={{ position: "relative" }}>
                                    <Table sx={{ minWidth: 650, textAlign: "center" }} className='financial-table' aria-label="simple table">
                                        <TableHead >
                                            <TableRow>
                                                <TableCell align="right">#</TableCell>

                                                <TableCell>مبلغ</TableCell>
                                                <TableCell align="right">وضعیت</TableCell>
                                                <TableCell align="right">نوع</TableCell>
                                                <TableCell align="right">تاریخ تراکنش</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {FinancialReport && FinancialReport.length > 0 ? FinancialReport.map((row) => (
                                                <TableRow
                                                    key={row.trans_id}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.trans_id}
                                                    </TableCell>
                                                    <TableCell align="right">{row.trans_amount}</TableCell>

                                                    <TableCell align="right">
                                                        {row.trans_type == "1" ? "سفارش سایت اختصاصی" : null}
                                                        {row.trans_type == "2" ? "خرید افزونه" : null}
                                                        {row.trans_type == "3" ? "افزایش اعتبار" : null}
                                                        {row.trans_type == "4" ? "شارژ سامانه پیامک" : null}
                                                        {row.trans_type == "5" ? "واریزی ها" : null}
                                                        {row.trans_type == "6" ? "خرید فایل" : null}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ color: row.status == "0" ? "#f76708" : "green" }}>
                                                        {row.status == "0" ? "پرداخت نشده" : null}
                                                        {row.status == "1" ? "پرداخت شده" : null}

                                                    </TableCell>
                                                    <TableCell align="right">{moment.unix(row.trans_date).format("jYYYY/jMM/jDD")}</TableCell>
                                                </TableRow>

                                            )) : !financialLoading && <Box sx={{ py: 2 }}>
                                                موردی یافت نشد!
                                            </Box>}
                                            {
                                                financialLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Box>
                    </Box>
                    {/* <Button className='green-btn' onClick={handleEdit} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>
            }

            {
                filterModal && <Dialog className="dialog-box"
                    fullScreen
                    open={filterModal}
                    onClose={handleFilterModalClose}
                    TransitionComponent={Transition}

                >
                    <AppBar sx={{ position: 'relative', bgcolor: '#fff', color: '#666666' }}>
                        <Toolbar>


                            <Typography sx={{ ml: 'auto', mr: 2, fontSize: "15px" }} variant="h6" component="div">
                                فیلتر ها
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleFilterModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>

                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 2, color: '#8F8F8F', px: 2, pb: 3 }}>
                        <Box>
                            <label className=' text-label'>وضعیت</label>
                            <Box className="inputs-container" sx={{ width: 'auto', p: 1, display: "flex", alignItems: "center", mt: 1 }}>
                                <select
                                    labelid="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={filterByStatus}
                                    onInput={handleChangeFilterStatus}
                                    className="select-control"
                                >
                                    <option selected value="">هیچکدام</option>
                                    <option selected value="1">سفارش سایت اختصاصی</option>
                                    <option value="2">خرید افزونه</option>
                                    <option value="3">افزایش اعتبار</option>
                                    <option value="4">شارژ سامانه پیامک</option>
                                    <option value="5">واریزی ها</option>
                                    <option value="6">خرید فایل</option>
                                </select>
                            </Box>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                            <label className=' text-label'>بر اساس تاریخ</label>
                            <Box className="inputs-container" sx={{ width: 'auto', p: 1, display: "flex", alignItems: "center", mt: 1 }}>
                                <select
                                    labelid="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={filterByDate}
                                    onInput={handleChangeFilterDate}
                                    className="select-control"
                                >
                                    <option selected value="">هیچکدام</option>
                                    <option value="today">امروز</option>
                                    <option value="7">7 روز گذشته</option>
                                    <option value="30">30 روز گذشته</option>
                                    <option value="costum">بازه دلخواه</option>
                                </select>
                            </Box>
                        </Box>
                        <Fade in={costumInputShow}>
                            <Box sx={{ mt: 2 }}>
                                <label className=' text-label'>بازه دلخواه</label>

                                <Grid container className="inputs-container" sx={{ mt: 1 }}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <div className='flex-1 w-chile-100'>
                                            <DatePicker calendar={persian} placeholder="تاریخ ثبت"
                                                locale={persian_fa} onChange={handleSetfromDate} />
                                        </div>
                                        <CalendarIcon />
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <div className='flex-1 w-chile-100'>
                                            <DatePicker onChange={handleSetToDate} calendar={persian} placeholder="تاریخ بازیابی"
                                                locale={persian_fa} />
                                        </div>

                                        <CalendarIcon />

                                    </Grid>
                                </Grid>
                            </Box>
                        </Fade>
                    </Box>
                    <Button className='green-btn' onClick={handleSetFilter} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog >
            }

            {
                openProvinceModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openProvinceModal}
                    onClose={handleProvinceClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            {provinceSelected ? <Button className='green-btn f-11' onClick={handleBackToProvince}>
                                استان ها
                            </Button> : ''}
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب شهر
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleProvinceClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>

                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                            <InputBase placeholder='جستجو کنید...' className='flex-1' onChange={handleSearch} />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {cityProvince && cityProvince.length ? cityProvince.map((item, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='cityProvince' value={item.Id} id={`cityProvince${index}`} className="d-none floorCheck" onChange={!provinceSelected ? handleProvinceSelected : handleSetCity} checked={!provinceSelected ? province == item.Id : city == item.Id} />
                                        <label htmlFor={`cityProvince${index}`} className='inputs-container floorLabel w-100'>
                                            <span className="flex-1">{item.FarsiName}</span>
                                        </label>
                                    </Grid>
                                )) : <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box>}
                            </Grid>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleSetCityInLocal} autoFocus
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>
            }

            {
                permissionsModal && <Dialog className="dialog-box"
                    fullScreen
                    open={permissionsModal}
                    onClose={handlePermissionsModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handlePermissionsModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>

                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, color: '#8F8F8F' }}>

                        <Box sx={{ px: 1, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Box className="f-16">مجموز های دسترسی {permissionsUser.username} را تعریف کنید.</Box>
                            <Grid container className='checkBox-group' sx={{ borderBottom: "1px solid #B1B1B1", pb: 2 }}>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_edit")
                                    }} checked={permissions && permissions.includes("property_edit")} />} label="ویرایش ملک" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_create")
                                    }} checked={permissions && permissions.includes("property_create")} />} label="ثبت ملک" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_delete")
                                    }} checked={permissions && permissions.includes("property_delete")} />} label="حذف ملک" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_archive")
                                    }} checked={permissions && permissions.includes("property_archive")} />} label="بایگانی ملک" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_share")
                                    }} checked={permissions && permissions.includes("property_share")} />} label="دسترسی به ارسال ملک" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_search")
                                    }} checked={permissions && permissions.includes("property_search")} />} label="جستجو ملک" />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_of_areas")
                                    }} checked={permissions && permissions.includes("property_of_areas")} />} label="دسترسی به ملک های محدوده" />
                                    <Box sx={{ width: '100%', mt: 1 }}>
                                        <Box className={`inputs-container border-0`} onClick={handleClickAreaPermissModal} sx={{ display: 'flex', border: "0px", width: 'auto', alignItems: 'center', cursor: 'pointer', justifyContent: 'space-between', bgcolor: "#F6F6F6" }}>
                                            <span> محدوده</span>
                                            <PlusIcon width="13" height="13" />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={11}>
                                    <FormControlLabel className='green-check' sx={{ mr: 0, mt: 1 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_just_self")
                                    }} checked={permissions && permissions.includes("property_just_self")} />} label="فقط ملک های ثبت شده توسط خود را 
مشاهده کند و به اطلاعات ملک های سایر 
کاربران دسترسی نداشته باشد" />
                                </Grid>
                            </Grid>
                            <Grid container className='checkBox-group' sx={{ borderBottom: "1px solid #B1B1B1", pb: 2 }}>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "applicant_edit")
                                    }} checked={permissions && permissions.includes("applicant_edit")} />} label="ویرایش تقاضا" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "applicant_create")
                                    }} checked={permissions && permissions.includes("applicant_create")} />} label="ثبت تقاضا" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "applicant_delete")
                                    }} checked={permissions && permissions.includes("applicant_delete")} />} label="حذف تقاضا" />
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "applicant_archive")
                                    }} checked={permissions && permissions.includes("applicant_archive")} />} label="بایگانی تقاضا" />
                                </Grid>
                                <Grid item xs={12} >
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "applicant_search")
                                    }} checked={permissions && permissions.includes("applicant_search")} />} label="جستجو تقاضا" />
                                </Grid>

                                <Grid item xs={11}>
                                    <FormControlLabel className='green-check' sx={{ mr: 0, mt: 1 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "applicant_just_self")
                                    }} checked={permissions && permissions.includes("applicant_just_self")} />} label="فقط تقاضا های ثبت شده توسط خود را 
مشاهده کند و به اطلاعات تقاضا های سایر 
کاربران دسترسی نداشته باشد" />
                                </Grid>
                            </Grid>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Box>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "buy_file_with_manager_wallet")
                                    }} checked={permissions && permissions.includes("buy_file_with_manager_wallet")} />} label="امکان افزودن فایل با استفاده ازموجودی مدیر" />
                                </Box>
                                <Box>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "add_reminder")
                                    }} checked={permissions && permissions.includes("add_reminder")} />} label="افزودن یاآوری" />
                                </Box>
                                <Box>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_label_just_self")
                                    }} checked={permissions && permissions.includes("property_label_just_self")} />} label="ثبت،ویرایش وحذف در بخش نشان گذاری ها وظایف فقط موارد ثبت شده به نام خود کاربرقابل دسترسی است" />                             </Box>
                                <Box>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_connection_just_self")
                                    }} checked={permissions && permissions.includes("property_connection_just_self")} />} label="ثبت،ویرایش وحذف در بخش ارتباطات (فقط موارد ثبت شده به نام خود کاربرقابل دسترسی است)" />
                                </Box>
                                <Box>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "financial_report")
                                    }} checked={permissions && permissions.includes("financial_report")} />} label="گزارشات مالی" />
                                </Box>
                                <Box>
                                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                        handleSetPermissions(e, "property_adaptation_by_other_users")
                                    }} checked={permissions && permissions.includes("property_adaptation_by_other_users")} />} label="امکان انطباق سازی فایل های ثبت شده توسط سایر کاربران" />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleSendPermissions} autoFocus
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
                </Dialog>
            }


            {
                areaPermissModal && <Dialog className="dialog-box"
                    fullScreen
                    open={areaPermissModal}
                    onClose={handleAreaPermissModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto', fontSize: '13px' }} variant="h6" component="div">
                                انتخاب محدوده
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleAreaPermissModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ overflowX: 'hidden', p: 1 }}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-form-control-label-placement"
                            name="position"
                            defaultValue="end"
                            className='text-gray-f-13'
                            value={areaDisplay}
                        >
                            <FormControlLabel value={1} control={<Radio size="small" sx={{
                                color: '#29A19C', '&.Mui-checked': {
                                    color: '#29A19C',
                                },
                            }} />} label="می خواهم ازمحدوده های پایش استفاده کنم" onChange={() => setAreaDisplay(1)} />
                            <FormControlLabel value={2} control={<Radio size="small" sx={{
                                color: '#29A19C', '&.Mui-checked': {
                                    color: '#29A19C',
                                },
                            }} />} label="می خواهم ازمحدوده های خودم استفاده کنم" onChange={() => setAreaDisplay(2)} />
                        </RadioGroup>
                        {areaDisplay == 1 ? <Box>
                            <Typography component='p' sx={{ color: '#666666', fontSize: '14px', textAlign: 'center', mt: 2 }}>
                                محدوده های پیشنهادی پایش
                            </Typography>
                            <Box sx={{ mt: 3, color: '#8F8F8F' }}>

                                <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 220px)!important", overflow: 'auto' }} id="areas-container">
                                    <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                        {
                                            areasItems && areasItems.length > 0 ?
                                                areasItems.map((item, index) => (

                                                    <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                        <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                        <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center' }}>
                                                            <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                            {/* <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                            <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton>
                                                        </div> */}
                                                        </label>
                                                    </Box>
                                                ))
                                                : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                        }
                                        {
                                            areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                        }
                                    </Box>
                                </Box>
                            </Box>
                        </Box> : null}
                        {areaDisplay == 2 ? <Box>

                            <Box sx={{ mt: 3, color: '#8F8F8F' }}>

                                <Box sx={{ color: '#8F8F8F', height: "calc(100vh - 200px)!important", overflow: 'auto' }} id="areas-container">
                                    <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                                        {
                                            areasItems && areasItems.length > 0 ?
                                                areasItems.map((item, index) => (

                                                    <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                                        <input type="radio" name='propertyType' value={item.Name} data_locationid={item.LocationId} id={`PropertyArea${index}`} className="d-none floorCheck" />
                                                        <label htmlFor={`PropertyArea${index}`} className='inputs-container floorLabel w-100' style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'right' }}>
                                                            <div style={{ flex: "2", paddingRight: '10px' }}>{item.Name}</div>
                                                            <div style={{ display: 'flex', gap: '5px', flex: "1", justifyContent: "center" }}>
                                                                {/* <IconButton onClick={() => handleClickOpenDeleteAreaModal(item.id)}>
                                                                <img src='/assets/img/DeleteIcon.png' />
                                                            </IconButton>
                                                            <IconButton onClick={() => handleEditAreaModalOpen(item.id, item.Name)}>
                                                                <img src='/assets/img/EditIcon.png' />
                                                            </IconButton> */}
                                                            </div>
                                                        </label>
                                                    </Box>
                                                ))
                                                : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                        }
                                        {
                                            areasLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                                        }
                                    </Box>
                                </Box>
                            </Box>
                        </Box> : null}
                    </Box>
                    {/* <Button
                    onClick={handleOpenLocalModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
                </Dialog>
            }

            {myInfoModal && <MyInfoModal myInfoModal={myInfoModal} handleMyInfoModalClose={handleMyInfoModalClose} handleSeMyInfoList={handleSeMyInfoList} myInfoList={myInfoList} setMyInfoList={setMyInfoList} saveMyInfo={saveMyInfo} />}

            {supportModal && <ModalComponent showModalState={supportModal}
                handleModalClose={handleSupportModalClose}
                modalTitle=""
                hasSpecificParent={true}
                disableSubmitBtn={true}
            >
                <Box sx={{ px: 2, color: '#8F8F8F' }}>
                    <Box sx={{ display: "flex", justifyContent: "start", alignItems: "start", gap: "5px", fontSize: "14px" }}>
                        <img src="/assets/img/logopayesh.png" />
                        <Box>
                            سامانه مدیریت ارتباط با مشتری
                            فایلینگ املاک و پایش
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 3, width: "100%" }}>
                        <Button className='inputs-container' sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href="#" style={{ display: "flex", gap: "10px", width: "100%", alignItems: "center" }}>
                                <NotifIcon />
                                <Box sx={{ flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "start" }}>گفتوگو با پایش</Box>
                                </Box>
                            </a>
                        </Button>
                        <Button className='inputs-container' sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`tel:05137253582`} style={{ display: "flex", gap: "10px", width: "100%", alignItems: "center" }}>
                                <MobileGrayIcon width="10px" height="17px" />
                                <Box sx={{ flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "start", direction: "ltr" }}>051_37253582</Box>
                                </Box>
                            </a>
                        </Button>
                        <Button className='inputs-container' sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`tel:09332860448`} style={{ display: "flex", gap: "10px", width: "100%", alignItems: "center" }}>
                                <img src='/assets/img/GrayPhoneIcon.png' style={{ width: "12px", height: "14px" }} />
                                <Box sx={{ flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "start", direction: "ltr" }}>09332860448</Box>
                                </Box>
                            </a>
                        </Button>
                        <Button className='inputs-container' sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`tel:05137284311`} style={{ display: "flex", gap: "10px", width: "100%", alignItems: "center" }}>
                                <MobileGrayIcon width="10px" height="17px" />
                                <Box sx={{ flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "start", direction: "ltr" }}>051_37284311</Box>
                                </Box>
                            </a>
                        </Button>
                    </Box>
                    <Box sx={{ bgcolor: "#838583", borderRadius: "5px", p: 2, mt: 2, display: "flex", flexDirection: "column", gap: "10px" }}>
                        <a href='' style={{ display: "flex", alignItems: "center", gap: "5px", color: "#FFFFFF" }}>
                            <LampIcon />
                            <Box sx={{ color: "#fff" }}>
                                درباره ما
                            </Box>
                        </a>
                        <a href='' style={{ display: "flex", alignItems: "center", gap: "5px", color: "#FFFFFF" }}>
                            <img src='/assets/img/tavafogh.png' />
                            <Box sx={{ color: "#fff" }}>
                                توافق نامه وتعهدات
                            </Box>
                        </a>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px", color: "#FFFFFF" }}>
                            مارا در شبکه های اجتماعی دنبال کنید
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", color: "#FFFFFF" }}>
                            <a href='#' style={{ display: "block", width: "16px", height: "16px" }}>
                                <img src='/assets/img/telgram.png' />
                            </a>
                            <a href='#' style={{ display: "block", width: "16px", height: "16px" }}>
                                <img src='/assets/img/insta.png' />
                            </a>
                        </Box>
                    </Box>
                </Box>
            </ModalComponent>}


            {labelsModal && <ModalComponent showModalState={labelsModal}
                handleModalClose={handleLabelsModalClose}
                modalTitle="نشان گذاری ها"
                disableSubmitBtn={true}
                hasSpecificParent={true}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", p: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                        <Button className='inputs-container border-0' onClick={handleClickAddLabelsModal} sx={{ p: 1, bgcolor: "#F6F6F6", display: "flex", justifyContent: "space-around" }}>
                            <PlusIcon width="15px" />
                            نشان گذاری جدید
                            <ArrowRightIcon className='rotate-180-minus' />
                        </Button>
                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                    </Box>

                    {
                        labels && labels.length > 0 ?
                            labels.map((item, index) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                                    <Box className='border-0 labels-item w-100' sx={{ p: 1, bgcolor: newShade(item.ColorCode, 40) }}>
                                        <Box className="circle-color" sx={{ bgcolor: item.ColorCode }}></Box>
                                        <Box sx={{ flex: "1", textAlign: "center", color: lightOrDark(item.ColorCode) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                                            {item.Text}
                                        </Box>
                                    </Box>
                                    {item?.RegistrarAgency != "00000000-0000-0000-0000-000000000000" ? <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} onClick={e => handleEditLabelModal(item.Id, item.Text, item.ColorCode)}>
                                        <IconButton><img src='/assets/img/EditIcon.png' /></IconButton>
                                    </Box> : <Box sx={{ width: "36px", height: "36px", p: "6px" }}></Box>}
                                </Box>
                            ))
                            : !labelsLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                    }
                    {
                        labelsLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                    }

                    {/* <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                        <Button className='border-0 labels-item' sx={{ p: 1, bgcolor: "#FAF3C0!important" }}>
                            <Box className="circle-color" sx={{ bgcolor: "#F5DD29" }}></Box>
                            <Box sx={{ flex: "1", textAlign: "center" }}>
                                فوری
                            </Box>
                        </Button>
                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <IconButton><img src='/assets/img/EditIcon.png' /></IconButton>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                        <Button className='border-0 labels-item' sx={{ p: 1, bgcolor: "#D6ECD2!important" }}>
                            <Box className="circle-color" sx={{ bgcolor: "#7BC86C" }}></Box>
                            <Box sx={{ flex: "1", textAlign: "center" }}>
                                پیگیری شود
                            </Box>
                        </Button>
                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <IconButton><img src='/assets/img/EditIcon.png' /></IconButton>
                        </Box>
                    </Box> */}
                </Box>
            </ModalComponent>}

            {addLabelsModal && <ModalComponent showModalState={addLabelsModal}
                handleModalClose={handleAddLabelsModalClose}
                modalTitle=""
                modalSubmitBtn={handleSaveLabel}
                modalTitleSubmitBtn="ایجاد">
                <Box sx={{ display: "flex", alignItems: "center" }}>

                    <Box className='border-0 labels-item w-100' sx={{ p: 1, bgcolor: newShade(labelColorSelected, 40) }}>
                        <Box className="circle-color" sx={{ bgcolor: labelColorSelected }}></Box>
                        <Box sx={{ flex: "1", textAlign: "center", color: lightOrDark(labelColorSelected) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                            {labelTitleSelected}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{ width: '100%' }}>
                    <label className='f-16 text-label'>عنوان</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase className='flex-1' onChange={(e) => setLabelTitleSelected(e.target.value)} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label className='f-16 text-label' style={{ display: "block", marginBottom: "10px" }} >انتخاب رنگ</label>
                    <div class="color-grid-container">
                        {labelColors.map((item, index) => {
                            return <div class="color-grid-item" >
                                <input type='radio' name='leble-color' id={`color${index}`} value={item} className='color-check d-none' onChange={(e) => setLabelColorSelected(e.target.value)} />
                                <label for={`color${index}`} style={{ backgroundColor: item }}></label>
                            </div>
                        })}

                    </div>
                    <Button sx={{ color: "#707070", p: 2, margin: "10px auto", display: "flex", alignItems: "center", gap: "10px" }} onClick={() => setLabelColorSelected("#aeaeae")}>حذف رنگ <CloseIcon /></Button>
                </Box>
            </ModalComponent>}

            {editLabelModal && <ModalComponent showModalState={editLabelModal}
                handleModalClose={handleEditLabelModalClose}
                modalTitle=""
                modalSubmitBtn={handleEditLabel}
                modalTitleSubmitBtn="ویرایش"
                modalHeaderRightBtn={true}
                headerRightBtnFunction={handleDelLabelModal}
                headerRightBtnClass="rounded-50"
                headerRightBtnTitle="حذف نشان گذاری"
                headerRightBtnStyle={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }}>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box className='border-0 labels-item w-100' sx={{ p: 1, bgcolor: newShade(labelSelectedEdit.ColorCode, 40) }}>
                        <Box className="circle-color" sx={{ bgcolor: labelSelectedEdit.ColorCode }}></Box>
                        <Box sx={{ flex: "1", textAlign: "center", color: lightOrDark(labelSelectedEdit.ColorCode) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                            {labelSelectedEdit.Text}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label className='f-16 text-label'>عنوان</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase className='flex-1' value={labelSelectedEdit.Text} onChange={(e) => setLabelSelectedEdit({ ...labelSelectedEdit, Text: e.target.value })} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label className='f-16 text-label' style={{ display: "block", marginBottom: "10px" }} >انتخاب رنگ</label>
                    <div class="color-grid-container">
                        {labelColors.map((item, index) => {
                            return <div class="color-grid-item" >
                                <input type='radio' name='leble-color' id={`color${index}`} value={item} className='color-check d-none' checked={labelSelectedEdit.ColorCode == item} onChange={(e) => setLabelSelectedEdit({ ...labelSelectedEdit, ColorCode: e.target.value })} />
                                <label for={`color${index}`} style={{ backgroundColor: item }}></label>
                            </div>
                        })}

                    </div>
                    <Button sx={{ color: "#707070", p: 2, margin: "10px auto", display: "flex", alignItems: "center", gap: "10px" }} onClick={(e) => setLabelSelectedEdit({ ...labelSelectedEdit, ColorCode: "#aeaeae" })}>حذف رنگ <CloseIcon /></Button>
                </Box>
            </ModalComponent>}

            {
                deleteLabelModal && <Dialog className="dialog-box"
                    open={deleteLabelModal}
                    onClose={handleDelLabelModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید این نشان گذاری را حذف کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDelLabelModalClose}>خیر</Button>
                        <Button onClick={handleDeleteLabel} autoFocus>
                            {!labelDeleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {messageTemplateModal && <ModalComponent showModalState={messageTemplateModal}
                handleModalClose={handleMessageTemplateModalClose}
                modalTitle=""
                hasSpecificParent={true}
                modalSubmitBtn={handleSetTemplate}
                modalTitleSubmitBtn="انتخاب">
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "100%" }}>
                    <Grid container sx={{ height: "100%" }}>
                        <Grid item xs={6}>
                            <label className='f-16 text-label' style={{ display: "block", marginBottom: "10px" }} >قالب متن</label>

                            <textarea onChange={e => setTexttemplate(e.target.value)} value={texttemplate} style={{ fontSize: "12px", width: "92%", borderRadius: "5px", border: "solid 1px #777", height: "90%" }}></textarea>
                        </Grid>
                        <Grid item xs={6} sx={{ borderRight: "solid 1px", pt: 4 }}>
                            {Object.keys(messageTemplate).map((item, index) => {
                                return <Button sx={{ width: "100%", display: "block" }}>
                                    <input type="checkbox" name='messageTemp' id={`messageTemp${index}`} value={messageTemplate[item]} checked={texttemplate.includes(messageTemplate[item])} className="d-none typeCheck" onChange={e => handleSetTempText(e)} />
                                    <label htmlFor={`messageTemp${index}`} className='typeLabel w-100 text-center' style={{ padding: "0px" }}>
                                        <span className="flex-1">{messageTemplate[item]}</span>
                                    </label>
                                </Button>
                            })}
                        </Grid>
                    </Grid>
                </Box>
            </ModalComponent>}

            {possiblitiModal && <ModalComponent showModalState={possiblitiModal}
                handleModalClose={handlePossiblitiModalClose}
                modalTitle=""
                hasSpecificParent={false}
                disableSubmitBtn={true}>
                <Grid container spacing={2} className='setting-content'>
                    <Grid item xs={12}>
                        <Button className='green' sx={{ display: "flex", alignItems: "center", justifyContent: "start!important", flexDirection: "row!important", gap: "10px!important" }}>
                            <img src='/assets/img/site-img.png' alt="" />
                            <Box>
                                ایجاد سایت اختصاصی املاک
                            </Box>
                        </Button>
                    </Grid>
                </Grid>
                <Box sx={{ backgroundColor: "#F6F6F6", p: 2, borderRadius: "5px", color: "#707070", display: "flex", flexDirection: "column", gap: "15px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Box><img src='/assets/img/backup-img.png' /> </Box>
                        <Box>
                            پشتیبان گیری وحفاظت از اطلاعات
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Box><img src='/assets/img/print-img.png' /> </Box>
                        <Box>
                            چاپ اطلاعات
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Box><img src='/assets/img/robot-img.png' /> </Box>
                        <Box>
                            ربات تلگرام
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Box><img src='/assets/img/export-excel.png' /> </Box>
                        <Box>
                            خروجی و ورودی اکسل
                        </Box>
                    </Box>
                    <Box>
                        جهت استفاده از سایر امکانات پایش
                        نسخه ویندوزی را از سایت زیر نصب
                        کنید
                    </Box>
                    <Box sx={{ textAlign: "end" }}>
                        <a href='app.payesh.me' className='text-blue'>app.payesh.me</a>
                    </Box>
                    <Box>
                        با همان شماره موبایلی که در ابتدا در
                        پایش ثبت نام کرده اید نسخه ویندوزی
                        را فعال کنید
                    </Box>
                </Box>

            </ModalComponent>}
        </>
    );
}

export default Settings;